import MainLayout from '@/views/Layout/MainLayout.vue';
import NotFound from '@/views/NotFoundPage.vue';

const routes = [
  {
    path: '/',
    redirect: 'deposit',
    component: MainLayout,
    children: [
      {
        path: '/',
        name: 'deposit',
        component: () => import('../views/Deposit.vue')
      },
      {
        path: '/term-and-conditions',
        name: 'deposit',
        component: () => import('../views/TermAndConditions.vue')
      },
      {
        path: '/privacy-and-policy',
        name: 'deposit',
        component: () => import('../views/PrivacyAndPolicy.vue')
      },
      { path: '*', component: NotFound }
    ]
  }
];

export default routes;
